module.exports = __webpack_public_path__ + "static/media/developers-mobile.4345f280.jpeg";